<template>
  <div>
    <div class="mx-3">
      <v-list-item>
        <v-list-item-content class="overflow-visible">
          <div class="group-btn-search">
            <v-menu
              :internal-activator="true"
              v-model="closeMenu"
              content-class="menu__customer no-contain overflow-visible"
              :close-on-content-click="false"
            >
              <template v-slot:activator="menuON">
                <v-btn
                  class="search-contact--text-blue px-4"
                  small
                  color="mx-0"
                  v-on="menuON.on"
                >
                  <span>Tìm kiếm</span>
                </v-btn>
              </template>
              <performacne-filter :filterForm="filterForm" @searchContent="searchContent($event)" @closeMenu="closeMenuDialog($event)" />
            </v-menu>
          </div>
        </v-list-item-content>
      </v-list-item>
    </div>
    <PerformaceTable  :dataReport="dataReport" :totalReport="totalReport" :totalPage="totalPage" @changePage="changePagination($event)" />
  </div>
</template>

<script>
import PerformaceTable from "./components/PerformaceTable.vue";
import PerformacneFilter from "./components/PerformacneFilter.vue";
import ReportRepository from "@/repositories/ReportRepository";
import * as moment from 'moment';

export default {
  name: "PerformanceMkt",
  components: {
    PerformaceTable,
    PerformacneFilter,
  },
  data() {
    return {
      filterForm: {
        page: 1,
        limit: 10,
        date_from: moment().format("YYYY-MM-DD 00:00:00"),
        date_to: moment().format("YYYY-MM-DD 23:59:59"),
        fanpage_id: null,
        master_id: null,
        marketer_id: null,
        content_id: null,
        ad_id: null,
      },
      closeMenu: false,
      dataReport: [],
      totalReport: {},
      totalPage: 0,
    };
  },
  async created() {
    await this.getDataReportMKT(this.filterForm);
  },
  methods: {
    searchContact() {},
    closeMenuDialog(value) {
      this.filterForm.closeMenu = value;
    },
    async getDataReportMKT(param) {
      const loading = this.$loading.show();
      const response = await ReportRepository.getDataMKTReport(param);
      if (response.data) {
        this.dataReport = response.data.data;
        this.totalReport = response.data.totalReport;
        this.totalPage = response.data.metaData && response.data.metaData.length ? response.data.metaData[0].totalPage : 0;
      }
      loading.hide();
    },
    changePagination(val) {
      this.filterForm.page = val;
      this.getDataReportMKT(this.filterForm);
    },
    searchContent(val) {
      this.filterForm = val;
      this.getDataReportMKT(this.filterForm);
    },
  },
};
</script>
<style lang="scss">
.search-contact--text-blue {
  background-color: #3aa55f !important;
  color: #fff;
  padding: 8px 16px !important;
}
.search-contact--text-oreange {
  background-color: #ff8057 !important;
  color: #fff;
  padding: 8px 16px !important;
}
</style>
<style lang="scss" scoped>
.m--contact-assignedAt .daterangepicker.openscenter {
  left: calc(50% + 100px) !important;
}
.m--contact-appointmentAt .daterangepicker.openscenter {
  left: 0 !important;
}
.group-btn-search {
  position: absolute;
  top: 8px;
  right: 0px;
  max-width: 130px;
  button {
    width: 100px;
  }
}
.group-btn-search .search-contact--dropdown {
  position: absolute;
  right: -10px;
  z-index: 1;
  top: -7px;
}
.menu__customer {
  top: calc(10% - 10px) !important;
  left: 99% !important;
  transform: translateX(-96%) !important;
}
@media (max-width: 1440px) {
  .menu__customer {
    top: calc(20% - 70px) !important;
    left: 99% !important;
    transform: translateX(-96%) !important;
  }
}
.search-name-contact .v-input__slot {
  width: calc(95% - 50px);
}
.search-name-contact input {
  font-size: 13px !important;
}
</style>
